import React from 'react';
import { motion } from 'framer-motion';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';
import icons from '../../../../constants/icons';

function SteamGameImportHeader() {
  const { t } = useTranslation();

  return (
    <div className="row justify-content-center">
      <div className="col-lg-8 text-center">
        <motion.div
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
        >
          <div className="d-flex align-items-center justify-content-center mb-3">
            <div className="p-3 glass-panel glow-cyan me-3">
              <FontAwesomeIcon
                icon={icons.STEAM}
                className="text-blue"
                size="2x"
              />
            </div>
            <h1 className="display-4 fw-bold mb-0">
              {t('ALASKA')} <span className="text-blue">{t('STEAM SYNC')}</span>
            </h1>
          </div>
          <p className="lead text-light opacity-75">
            {t('Advanced Automated Catalog Import & SKU Generation')}
          </p>
        </motion.div>
      </div>
    </div>
  );
}

export default SteamGameImportHeader;
